// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./banana.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./bk-foot.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banana{
    font-family: 'Rubik', sans-serif;
    color:#000;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}),url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: 210px, 33px ;
    background-repeat: no-repeat, repeat-x;
    background-position: center bottom, 0 193px;

    bottom: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: end;
    text-align: center;
    height: 257px;
 display: flex;
  text-decoration: none;
    padding: 21px 121px;
}
.banana a{text-decoration: none; color: black; cursor:help;}
.copy p {color: #000;}

.imgBanana{
bottom: 0
;}


@media screen and (max-width: 671px) {
  .banana{flex-direction:column;
    justify-content: flex-end;
    align-items: flex-end;

    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 210px ;
    background-repeat: no-repeat;
    background-position: left bottom;
    
  }
  .social {display: none;}
  .copy {
    /* transform: rotate(90deg); */
  }
}
@media screen and (max-width: 400px) {
  .banana{flex-direction:column;
    
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}),url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 33px, 210px ;
    background-repeat: repeat-x, no-repeat;
    background-position: 0 193px, center 0px;  
  
  
  }

  .copy { 
    
    bottom: 78px;
  
    right: -5px;
 }

}
`, "",{"version":3,"sources":["webpack://./src/components/footer/footer.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,UAAU;IACV,2FAAgD;IAChD,6BAA6B;IAC7B,sCAAsC;IACtC,2CAA2C;;IAE3C,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;CAChB,aAAa;EACZ,qBAAqB;IACnB,mBAAmB;AACvB;AACA,UAAU,qBAAqB,EAAE,YAAY,EAAE,WAAW,CAAC;AAC3D,SAAS,WAAW,CAAC;;AAErB;AACA;AACA,CAAC;;;AAGD;EACE,QAAQ,qBAAqB;IAC3B,yBAAyB;IACzB,qBAAqB;;IAErB,mDAA6B;IAC7B,uBAAuB;IACvB,4BAA4B;IAC5B,gCAAgC;;EAElC;EACA,SAAS,aAAa,CAAC;EACvB;IACE,8BAA8B;EAChC;AACF;AACA;EACE,QAAQ,qBAAqB;;IAE3B,2FAAgD;IAChD,6BAA6B;IAC7B,sCAAsC;IACtC,wCAAwC;;;EAG1C;;EAEA;;IAEE,YAAY;;IAEZ,WAAW;CACd;;AAED","sourcesContent":[".banana{\n    font-family: 'Rubik', sans-serif;\n    color:#000;\n    background: url(./banana.png),url(./bk-foot.gif);\n    background-size: 210px, 33px ;\n    background-repeat: no-repeat, repeat-x;\n    background-position: center bottom, 0 193px;\n\n    bottom: 0;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: end;\n    text-align: center;\n    height: 257px;\n display: flex;\n  text-decoration: none;\n    padding: 21px 121px;\n}\n.banana a{text-decoration: none; color: black; cursor:help;}\n.copy p {color: #000;}\n\n.imgBanana{\nbottom: 0\n;}\n\n\n@media screen and (max-width: 671px) {\n  .banana{flex-direction:column;\n    justify-content: flex-end;\n    align-items: flex-end;\n\n    background: url(./banana.png);\n    background-size: 210px ;\n    background-repeat: no-repeat;\n    background-position: left bottom;\n    \n  }\n  .social {display: none;}\n  .copy {\n    /* transform: rotate(90deg); */\n  }\n}\n@media screen and (max-width: 400px) {\n  .banana{flex-direction:column;\n    \n    background: url(./bk-foot.gif),url(./banana.png);\n    background-size: 33px, 210px ;\n    background-repeat: repeat-x, no-repeat;\n    background-position: 0 193px, center 0px;  \n  \n  \n  }\n\n  .copy { \n    \n    bottom: 78px;\n  \n    right: -5px;\n }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
